import React, { useMemo } from 'react';
import Loader from '../loader';
import { FlexColumn } from './html';
import TestRunningText from '../../performance-scan-compare/components/TestRunningText';
import { isTestFinished } from '../../../helpers/get-scan-results';

function generateTexts(testRequest) {
  const mainTestUrl = testRequest.friendlyTestUrl;
  if (testRequest.tests.length === 0) {
    const urls = [...(testRequest.additionalTestUrls || [])];
    urls.unshift(mainTestUrl);
    return urls.map((url, idx) => (
      <TestRunningText
        key={url}
        text={url}
        flags={idx === 0 ? [] : testRequest.flags}
        finished={false}
        mainTestUrl={mainTestUrl}
      />
    ));
  }
  return testRequest.tests.map(
    ({
      friendlyTestUrl = '',
      finished = false,
      flags = [],
    }) => (
      <TestRunningText
        key={friendlyTestUrl}
        text={friendlyTestUrl}
        flags={flags}
        finished={finished}
        mainTestUrl={mainTestUrl}
      />
    ),
  );
}


function PerfscanLoader({ data = [] }) {
  const isDone = useMemo(() => {
    if (!data || data.length === 0) return false;

    return isTestFinished(data);
  }, [data]);

  const testRunTexts = useMemo(() => {
    if (!data || data.length === 0) {
      return null;
    }

    let texts;
    if (data.length === 1) { // Test init, but not yet started
      texts = generateTexts(data[0]);
    } else if (data.length > 1) {
      texts = data.map((testRequest) => {
        const tests = [...testRequest.tests];
        if (tests.length > 0) tests.length = 1;
        return generateTexts({ ...testRequest, additionalTestUrls: [], tests });
      });
    }

    if (isDone) {
      texts.push(<TestRunningText text="Calculating results" key="perfscan-calculating-scores" />);
    }

    return texts;
  }, [data, isDone]);

  if (!data) {
    return <Loader />;
  }

  return (
    <Loader>
      <FlexColumn>
        {testRunTexts}
      </FlexColumn>
    </Loader>
  );
}

export default PerfscanLoader;
